import { InputProps, Input as NextUInput } from '@nextui-org/react';

export function Input(props: InputProps) {
  return (
    <NextUInput
      classNames={{
        inputWrapper: [
          'bg-white',
          'shadow-none',
          'border-2',
          props.isDisabled ? 'border-default' : 'border-primary',
        ],
      }}
      {...props}
    >
      {props.children}
    </NextUInput>
  );
}
